import { Label, RadioGroup, RadioGroupItem } from '@massilia/ui'

import type { PaymentFilterValue } from '@/lib/schemas/flight-results-search.schema'

import { useInstallmentPartner } from '../use-installment-partner'
import { FilterDrawer } from './filter-drawer'
import { useFiltersState } from './filters-state-context'

export function PaymentFilter() {
  const {
    filters: { filterPayment },
    setFilters,
  } = useFiltersState()
  const partner = useInstallmentPartner()

  const options: { label: string; value: PaymentFilterValue }[] = [
    { label: 'Tous les paiements', value: 'all' },
    { label: 'Paiement Massilia Voyages', value: 'massilia' },
    { label: `Paiement 1 fois ou via ${partner.name}`, value: 'partner' },
  ]

  return (
    <FilterDrawer title="Type de paiement">
      <RadioGroup
        className="flex flex-col gap-2"
        onValueChange={(val) => {
          setFilters({ filterPayment: val as PaymentFilterValue })
        }}
        value={filterPayment ?? 'all'}
      >
        {options.map((option) => (
          <Label
            className="flex cursor-pointer items-center gap-2"
            htmlFor={`payment-${option.value}`}
            key={option.value}
          >
            <RadioGroupItem id={`payment-${option.value}`} value={option.value} />
            <span className="text-sm text-gray-700">{option.label}</span>
          </Label>
        ))}
      </RadioGroup>
    </FilterDrawer>
  )
}
